import React, { useCallback } from 'react';

import { useUserContext } from 'providers/UserProvider';

import Table from 'components/common/Table';

import { shipmentApi } from 'api';

import {
  getShipmentListTab,
  getShipmentListColumns,
  SHIPMENT_FILTER_OPTIONS,
} from 'constants/shipment';

const Shipment = () => {
  const { selectedTenant, selectedWarehouse } = useUserContext();
  const tenant = selectedTenant?.domains?.[0]?.domain;
  const warehouse = selectedWarehouse?.domain;

  const initialFilter = { warehouse: selectedWarehouse?.id };

  const exportApi = useCallback(params => {
    return shipmentApi.exportShipment(params);
  }, []);

  return (
    <Table
      title="Shipments"
      apiService={shipmentApi}
      exportApi={exportApi}
      sortable={true}
      columns={getShipmentListColumns(tenant, warehouse)}
      filterOptions={SHIPMENT_FILTER_OPTIONS}
      tabOptions={getShipmentListTab(initialFilter)}
      initialFilter={initialFilter}
    />
  );
};

export default Shipment;
